/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goals_SubInputs */

const en_funnel_ob_goals_sub = /** @type {(inputs: Funnel_Ob_Goals_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick all that apply. We'll show you exactly how we help with each.`)
};

const es_funnel_ob_goals_sub = /** @type {(inputs: Funnel_Ob_Goals_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige todo lo que aplique. Te mostraremos exactamente cómo te ayudamos con cada cosa.`)
};

/**
* | output |
* | --- |
* | "Pick all that apply. We'll show you exactly how we help with each." |
*
* @param {Funnel_Ob_Goals_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goals_sub = /** @type {((inputs?: Funnel_Ob_Goals_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goals_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goals_sub(inputs)
	return en_funnel_ob_goals_sub(inputs)
});